import en_GB_addListing from "./en-GB/add-listing";
import en_GB_agencyBranch from "./en-GB/agency-branch";
import en_GB_agentools from "./en-GB/agentools";
import en_GB_allocation from "./en-GB/allocations";
import en_GB_announcement from "./en-GB/announcement";
import en_GB_app from "./en-GB/app";
import eg_GB_bulkUpgrade from "./en-GB/bulkUpgrade";
import en_GB_dashboard from "./en-GB/dashboard";
import en_GB_enquiryManagement from "./en-GB/enquiry-management";
import en_GB_enquirySettings from "./en-GB/enquiry-settings";
import eg_GB_errors from "./en-GB/errors";
import eg_GB_extendListing from "./en-GB/extendListing";
import eg_GB_fsbo from "./en-GB/fsbo";
import en_GB_leads from "./en-GB/leads/index";
import en_GB_listing from "./en-GB/listing";
import en_GB_listings from "./en-GB/listings";
import en_GB_marketAnalytics from "./en-GB/market-analytics";
import en_GB_plans from "./en-GB/plans";
import en_GB_propertyWanted from "./en-GB/property-wanted/index.malaysia";
import en_GB_quality from "./en-GB/quality";
import eg_GB_readvertisement from "./en-GB/readvertisement";
import en_GB_reporting from "./en-GB/reporting";
import en_GB_reportings from "./en-GB/reportings";
import en_GB_scheduledManager from "./en-GB/scheduled-manager";
import en_GB_watermark from "./en-GB/watermark";
import en_GB_areaCondoSpecialist from "./en-GB/areaCondoSpecialist";
import en_GB_creditUsage from "./en-GB/creditUsage";
import en_GB_subscriptionRenewal from "./en-GB/subscription-renewal";
import en_GB_paymentResult from "./en-GB/payment-result";
import en_GB_paymentHistory from "./en-GB/payment-history";
import en_GB_dynamicPricing from "./en-GB/dynamic-pricing";
import en_GB_creditBrickz from "./en-GB/credit-brickz";
import en_GB_paymentSummary from "./en-GB/payment-summary";
import en_GB_locationIssue from "./en-GB/location-issue";

const enGB = {
  ...en_GB_addListing,
  ...en_GB_agencyBranch,
  ...eg_GB_errors,
  ...eg_GB_fsbo,
  ...en_GB_listings,
  ...en_GB_listing,
  ...en_GB_app,
  ...en_GB_announcement,
  ...eg_GB_readvertisement,
  ...eg_GB_bulkUpgrade,
  ...en_GB_reporting,
  ...en_GB_reportings,
  ...en_GB_plans,
  ...en_GB_enquirySettings,
  ...en_GB_enquiryManagement,
  ...en_GB_allocation,
  ...en_GB_quality,
  ...en_GB_watermark,
  ...en_GB_leads,
  ...en_GB_agentools,
  ...en_GB_propertyWanted,
  ...en_GB_marketAnalytics,
  ...en_GB_dashboard,
  ...en_GB_scheduledManager,
  ...eg_GB_extendListing,
  ...en_GB_areaCondoSpecialist,
  ...en_GB_creditUsage,
  ...en_GB_subscriptionRenewal,
  ...en_GB_paymentResult,
  ...en_GB_paymentHistory,
  ...en_GB_dynamicPricing,
  ...en_GB_creditBrickz,
  ...en_GB_paymentSummary,
  ...en_GB_locationIssue,
};

export default {
  "en-GB": enGB,
};
